/* eslint-disable react/no-deprecated */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as actions from '../../actions/index';
import { styles } from './LoyaltyProgram.styles';
import { LOYALTY_CONFIG, CASHBACK_TYPE, PRODUCT_TYPE, mainColor, UNIT } from '../../constants';
import { Divider, List, ListItem, ListItemIcon, ListItemText } from '@material-ui/core';
import { ChevronRight } from '@material-ui/icons';
import ArrowBackIosOutlinedIcon from '@material-ui/icons/ArrowBackIosOutlined';
import _ from 'lodash';
import BackButton from '../BackButton';
import CommonDesign from '../CommonDesign';
import { marketing } from '../../constants';
import logoScreen from '../../assets/pictures/logoScreen.png';
import { changeFidelityProgram, handleVersionClick, handleClick, handleRemoveVersion, getAllLoyaltyProgram, updateFidelityProgram } from './LoyaltyProgram.services';
import FidelityProgram from '../FidelityProgram';
import InputAdornment from '@material-ui/core/InputAdornment';
import Input from '../Input';
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutlined';
import Version from './LoyaltyVersion.view';
import { getALLMenus } from '../../apis/backend';
import IconButton from '../IconButton';
import AddIcon from '@material-ui/icons/Add';
function LoyaltyProgram({
    classes, history = {}, openErrorModal, showModal, loyalty
}) {
    const [stateObj, setStateObjRaw] = useState({
        isLoading: false,
        type: CASHBACK_TYPE,
        pointName: '',
        pointsPerEuro: 0,
        selected: 0,
        limit: null,
        cashBackPointsPerEuro: null,
        minBasket: null,
        title: '',
        versionTitle: '',
        config: '',
        versionConfig: '',
        isOpenConfiguration: false,
        isOpenShops: false,
        isOpenProducts: false,
        isShopsInfo: false,
        isDefault: false,
        updateVersions: true,
        createVersion: false,
        enabledProduct: true,
        enabledCashBack: true,
        commonProducts: [],
        newVersion: {},
        version: {},
        versions: {}
    });

    const [validationMessage, setValidationMessage] = useState({ limit: 0, cashBackPointsPerEuro: 0 });

    const setStateObj = myNewObj => setStateObjRaw(prevState => ({ ...prevState, ...myNewObj }));

    useEffect(() => {
        if (!stateObj.updateVersions) return;

        (async () => {
            try {
                if (loyalty?.type === PRODUCT_TYPE && loyalty?.enabled && stateObj.selected === 1) {
                    await getAllLoyaltyProgram(stateObj, setStateObj)
                }

                setStateObj({
                    pointName: loyalty?.productConfig?.pointName,
                    pointsPerEuro: loyalty?.productConfig?.pointsPerEuro,
                    minBasket: loyalty?.cashbackConfig?.minBasket,
                    type: loyalty?.type,
                    enabledProduct: loyalty?.type === PRODUCT_TYPE && loyalty?.enabled,
                    enabledCashBack: loyalty?.type === CASHBACK_TYPE && loyalty?.enabled,
                    cashBackPointsPerEuro: loyalty?.cashbackConfig?.pointsPerEuro
                        ? parseFloat((loyalty?.cashbackConfig?.pointsPerEuro * loyalty?.cashbackConfig?.limit).toFixed(2))
                        : null,
                    limit: loyalty?.cashbackConfig?.limit,

                });
            } catch (error) {
                console.error('Error fetching loyalty programs', error);
                setStateObj({ isLoading: false });
            }
        })();
    }, [stateObj.updateVersions, loyalty?.enabled, loyalty?.type, stateObj.selected]);

    useEffect(() => {
        const initializeState = () => {
            setStateObj(prevState => ({
                ...prevState,
                type: CASHBACK_TYPE,
                pointName: '',
                pointsPerEuro: 0,
                limit: null,
                cashBackPointsPerEuro: null,
                minBasket: null,
                title: '',
                versionTitle: '',
                config: '',
                versionConfig: '',
                isOpenConfiguration: false,
                isOpenShops: false,
                isOpenProducts: false,
                isShopsInfo: false,
                isDefault: false,
                updateVersions: true,
                createVersion: false,
                enabledProduct: true,
                enabledCashBack: true,
                commonProducts: []
            }));
        };

        initializeState();

        const fetchData = async () => {
            try {
                setStateObj({ isLoadingMenu: true });
                const menus = await getALLMenus();
                setStateObj({ menus, isLoadingMenu: false });
            } catch (error) {
                console.error('Error fetching menus', error);
                setStateObj({ isLoadingMenu: false });
            }
        };

        fetchData();
    }, []);

    useEffect(() => {
        setStateObj({
            pointName: loyalty?.productConfig?.pointName,
            type: loyalty?.type,
            pointsPerEuro: loyalty?.productConfig?.pointsPerEuro,
            enabledProduct: loyalty?.type === PRODUCT_TYPE && loyalty?.enabled,
            enabledCashBack: loyalty?.type === CASHBACK_TYPE && loyalty?.enabled,
            limit: loyalty?.cashbackConfig?.limit,
            cashBackPointsPerEuro: loyalty?.cashbackConfig?.pointsPerEuro ? parseFloat((loyalty?.cashbackConfig?.pointsPerEuro * loyalty?.cashbackConfig?.limit).toFixed(2)) : null,
            minBasket: loyalty?.cashbackConfig?.minBasket
        });
    }, [loyalty]);
    const renderConfiguration = () => {
        return (
            <div className='mt-3'>
                <>
                    <p className={classes.designText}>Nom de mes points</p>
                    <Input
                        margin='dense'
                        id='pointName'
                        value={stateObj.pointName}
                        className={classes.inputStyle}
                        placeholder='Points'
                        onChange={e => (setStateObj({ pointName: e.target.value }))}
                        fullWidth
                    />
                    <p className={classes.designText}>Taux de change</p>
                    <div className={classes.inputRow}>
                        <Input
                            disabled={true}
                            margin='dense'
                            id='limit'
                            value='1 € dépensé'
                            className={classes.inputStyle}
                            placeholder='1 € dépensé'
                        />
                        <span className={classes.equalsSign}>=</span>
                        <Input
                            margin='dense'
                            id='pointsPerEuro'
                            value={stateObj.pointsPerEuro}
                            onChange={e => (
                                setStateObj({ pointsPerEuro: e.target.value < 0 ? 0 : e.target.value })
                            )}
                            className={classes.inputStyle}
                            placeholder='Points'
                            InputProps={{
                                endAdornment: <InputAdornment position='end'>points</InputAdornment>
                            }}
                        />
                    </div>

                </>
            </div >
        )
    };
    const renderVersions = () => {
        return (
            <>
                <List>
                    <ListItem
                        className={`${classes.gutters} pl-1`}>
                        <ListItemText
                            style={{ color: mainColor.colorBlack }}
                            secondary={<p className={classes.textStyle}>Définissez plusieurs versions de votre programme de fidélité
                                selon les configurations de vos points de vente (connexion caisse, produits disponibles, prix…)</p>}
                        />
                        <IconButton className={classes.addIcon} onClick={() => setStateObj({ isOpenConfiguration: true, version: {}, createVersion: true })}>

                            <AddIcon />
                        </IconButton>
                    </ListItem>
                </List>
                {_.size(stateObj.versions) > 0 &&
                    <div className={classes.menu}>
                        <List>
                            {_.map(Object.values(stateObj.versions), (version, index) => {
                                const { versionName, defaultVersion, rules = {}, shops = {}, key } = version
                                return (
                                    <>
                                        <ListItem className={`${classes.gutters} pl-0`} key={key}>
                                            <ListItemText
                                                className={`${classes.version} col-6 `}
                                                primary={<p className={classes.version}>{versionName}</p>}
                                                secondary={defaultVersion && <p className={classes.textStyle}>Version par défaut</p>}
                                            />
                                            <Divider orientation="vertical" flexItem style={{ margin: '0 5px' }} />
                                            <ListItemText
                                                style={{ marginRight: -UNIT * 2.6875 }}
                                                secondary={<p className={classes.textStyle}>Restaurants inscrits: {shops.length}<br /> Panier minimum: {rules?.minBasket}€ </p>}
                                            />
                                            <IconButton className={classes.leftArrow} onClick={() => handleVersionClick(version, setStateObj, versionName)}>
                                                <ChevronRight />
                                            </IconButton>
                                        </ListItem>
                                        {index <= Object.values(stateObj.versions).length - 2 && <Divider component='li' />}
                                    </>
                                );
                            })}
                        </List>
                    </div>
                }
            </>
        );
    };

    const renderContent = () => {
        if (stateObj.config === 'Configuration') {
            return renderConfiguration();
        }
        if (stateObj.config === 'Versions') {
            return renderVersions();
        }

    };
    const renderProducts = () => {
        return (

            <List>
                {_.map(Object.values(LOYALTY_CONFIG), (config, index) => {
                    return (
                        <>
                            <ListItem
                                button
                                className={classes.gutters}
                                onClick={event => handleClick(event, index, setStateObj, config.text)}
                            >
                                <ListItemIcon className={classes.icon}>{config.icon}</ListItemIcon>
                                <ListItemText
                                    style={{ color: mainColor.colorBlack }}
                                    primary={config.text}
                                    secondary={<p className={classes.textStyle}>{config.description}</p>}
                                />
                                <ChevronRight style={{ color: mainColor.colorBlack }} className={classes.leftArrow} />
                            </ListItem>
                            {index <= Object.values(LOYALTY_CONFIG).length - 2 && <Divider component='li' />}
                        </>
                    );
                })}
            </List>

        );
    };
    const handleTitleClick = (config, onClick, isVersion) => {
        return (

            <>
                {config !== '' && (
                    <>
                        <List>
                            <ListItem
                                className={`${classes.listStyle} p-2`}
                                onClick={onClick}>
                                <ListItemIcon className={classes.iconStyle}>
                                    <IconButton style={{ color: mainColor.colorBlack }} >
                                        <ArrowBackIosOutlinedIcon />
                                    </IconButton>
                                </ListItemIcon>
                                <ListItemText
                                    className={classes.configText}

                                    primary={isVersion ? stateObj.versionTitle : stateObj.title}
                                />
                                {isVersion &&
                                    <ListItemIcon className={classes.leftArrow}>  <IconButton onClick={(e) => { handleRemoveVersion(stateObj, setStateObj, showModal); e.stopPropagation() }}> <DeleteOutlinedIcon /></IconButton>  </ListItemIcon>
                                }

                            </ListItem>
                        </List>
                        <Divider />

                    </>
                )}
                <div>{isVersion ? <Version stateObj={stateObj} setStateObj={setStateObj} openErrorModal={openErrorModal} showModal={showModal} /> : renderContent()}</div>
            </>


        );
    };

    const LoyaltyProgramComponent = (
        <>
            {
                stateObj.config === '' && stateObj.versionConfig === '' ? (
                    loyalty?.productConfig?.showProductsFid ? <div className={!stateObj.enabledProduct && classes.disabled} style={{ marginTop: -UNIT * 1.125 }}> {renderProducts()} </div> : <p className='text-center'>Si vous souhaitez activer la fidélité par produit, contactez votre account manager au plus vite !</p>
                ) : (
                    stateObj.versionConfig !== '' ? (
                        <div>{handleTitleClick(stateObj.versionConfig, () => setStateObj({ versionConfig: '' }), true)}</div>
                    ) :
                        (
                            <div>{handleTitleClick(stateObj.config, () => setStateObj({ config: '' }), false)}</div>
                        )
                )
            }
            {stateObj.isOpenConfiguration && stateObj.versionConfig === '' &&
                <Version stateObj={stateObj} setStateObj={setStateObj} openErrorModal={openErrorModal} showModal={showModal} />}
        </>
    );


    return (
        <>
            <div className='p-4'>
                <BackButton
                    className='p-0'
                    onClick={() => history.goBack()}
                    title={marketing.fidelityProgram.text}
                    subtitle={marketing.fidelityProgram.description}
                />
                <CommonDesign
                    child={stateObj.selected === 0 ? <FidelityProgram setStateObj={setStateObj} stateObj={stateObj} validationMessage={validationMessage} setValidationMessage={setValidationMessage} /> : LoyaltyProgramComponent}
                    src={logoScreen}
                    onClick={() =>
                        changeFidelityProgram(openErrorModal, stateObj, setStateObj)
                    }
                    isLoading={stateObj.isLoading}
                    title={`${stateObj.selected === 0
                        ? (stateObj.enabledCashBack ? 'Désactiver' : 'Activer')
                        : (stateObj.enabledProduct ? 'Désactiver' : 'Activer')
                        } mon programme de fidélité`}

                    checked={stateObj.selected === 0 ? stateObj.enabledCashBack : stateObj.enabledProduct}
                    onChange={() => {
                        if (stateObj.selected === 0) {
                            setStateObj({ enabledCashBack: !stateObj.enabledCashBack });
                        } else {
                            if (loyalty?.productConfig?.showProductsFid) {
                                updateFidelityProgram(stateObj, setStateObj)
                            }
                        }
                    }}

                    disabled={!loyalty?.enabled && (stateObj.selected === 0 ? !stateObj.enabledCashBack : !stateObj.enabledProduct)}
                    hasBottomNavigation={true}
                    handleChange={() => { setStateObj({ selected: stateObj.selected === 0 ? 1 : 0 }); }}
                    selected={stateObj.selected}
                    config={stateObj.config === ''}
                    withoutSaveButton={stateObj.config === 'Versions' || (stateObj.config === '' && stateObj.selected === 1)}
                    isConfig={stateObj.config === 'Configuration'}
                />

            </div>


        </>
    );
}


function mapStateToProps({ firebaseRealTime }) {
    const { generalConfig = {} } = firebaseRealTime;
    const { loyalty = {} } = generalConfig;
    return {
        loyalty
    };
}

export default connect(mapStateToProps, actions)(withStyles(styles)(withRouter(LoyaltyProgram)));
